export default function formatDate(inputDate, options, returnFullDate = false, language = "de") {
    const currentDate = new Date();
    const date = new Date(inputDate);

    const diffInMilliseconds = currentDate - date;
    const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (!returnFullDate) {
        if (diffInMinutes < 1) {
            return language === "en" ? "now" : "jetzt";
        } else if (diffInMinutes < 60) {
            return `${diffInMinutes} ${language === "en" ? "minutes ago" : "minuten her"}`;
        } else if (diffInHours < 24) {
            return `${diffInHours} ${language === "en" ? "hours ago" : "stunden her"}`;
        } else if (diffInDays < 30) {
            return `${diffInDays} ${language === "en" ? "days ago" : "tage her"}`;
        }
    }
    // Format the date in "dd.MM.yyyy" format with dots as separators
    return (
        !options ?
            date.toLocaleDateString(language === "en" ? 'en-UK' : 'de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '.')
            :
            date.toLocaleDateString(
                language === "en" ? 'en-UK' : 'de-DE',
                options
            )

    );
}